<template>
  <div
    class="grid grid-cols-[auto_1fr] rounded overflow-hidden border p-2 gap-3"
  >
    <div class="flex shrink-0 h-[9rem]">
      <div class="flex flex-col items-center bg-neutral aspect-[3/4]">
        <UserAvatar
          :avatar-url="character.avatarMedia?.url"
          alt=""
          class="h-full"
          @click="onClickMate(character.mate?.uuid)"
        />
      </div>
    </div>
    <div class="flex flex-col gap-1 flex-grow">
      <div class="flex flex-col">
        <div class="font-bold line-clamp-2">
          {{ useName(character.name) }}
        </div>
        <div class="text-base-content/50">
          {{ $t("game.role." + character.role) }}
        </div>
      </div>
      <div class="w-full flex-grow">
        <TextEllipsis
          :collapse-text="t('Buttons.collapse')"
          :content="
            character.introduction
              ? character.introduction
              : t('Texts.noIntroductionText')
          "
          :expand-text="t('Buttons.expand')"
          rows="3"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { TextEllipsis } from "vant";
import { useName } from "@/use/common";

defineProps<{
  character: GalGameCharacter;
}>();

const { t } = useI18n();
const router = useRouter();
const onClickMate = (mateUuid: any) => {
  mateUuid && router.push({ name: "mateHome", params: { uuid: mateUuid } });
};
</script>
